import axios from 'axios';

import { EndpointError } from '@iconik-io/iconik-api/src/client/response';

export const getSentryFingerprint = (
  error: Error,
  { tag }: { tag?: string } = {},
): string[] => {
  const fingerprint = [];
  if (tag) {
    fingerprint.push(tag);
  }
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      fingerprint.push(String(error.response?.status));
    }
    if (error.config?.url) {
      fingerprint.push(String(error.config.url));
    }
    if (error.config?.method) {
      fingerprint.push(String(error.config.method));
    }
  }
  if (error instanceof EndpointError) {
    if (error.response?.status) {
      fingerprint.push(String(error.response?.status));
    }
    if (error.request.url) {
      fingerprint.push(String(error.request.url));
    }
    if (error.request.method) {
      fingerprint.push(String(error.request.method));
    }
  }

  fingerprint.push(error.message);

  return fingerprint;
};
